import reducer from './exercises';
import { actionCreators, ExerciseActionType } from './exercises.actionCreators';
import * as actionTypes from './exercises.actionTypes';

export * from './exercises'; // expose all types
export * from './exercises.selectors';
export type ActionType = ExerciseActionType;
export { actionTypes, actionCreators };
export default reducer;
